import React from "react";
import { FaUserCircle, FaComments, FaListAlt, FaShareAlt, FaChartLine, FaUsers } from "react-icons/fa";

const TrvllrSocial = () => {
  return (
    <section id="social" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Header */}
        <h2 className="text-4xl font-bold text-white mb-6">
          Introducing <span className="bg-gradient-to-r from-purple-500 to-amber-500 bg-clip-text text-transparent">Trvllr™Social</span>
        </h2>
        <p className="text-lg text-gray-300 mb-12">
          Where healthcare professionals and recruiters connect, share, and grow. Build your network, join the conversation, and take your career to the next level.
        </p>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {socialFeatures.map((feature, index) => (
            <div
              key={index}
              className="relative social-card flex flex-col items-center text-center"
            >
              {/* Icon */}
              <feature.icon size={40} className="text-purple-400 mb-4 z-10 relative" />

              {/* Title */}
              <h3 className="text-xl font-bold text-purple-400 mb-2 relative z-10">{feature.title}</h3>

              {/* Description */}
              <p className="text-gray-400 relative z-10">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/** Social Features Data */
const socialFeatures = [
  { title: "Account Profiles", description: "Showcase your expertise, work history, and preferences.", icon: FaUserCircle },
  { title: "Community Forums", description: "Join Lounges for specialties and Havens for sub-specialties.", icon: FaComments },
  { title: "General Feed", description: "Stay updated with personalized timelines featuring posts, news, and jobs.", icon: FaListAlt },
  { title: "Social Features", description: "Connect, follow, post, and engage with professionals.", icon: FaShareAlt },
  { title: "Professional Growth", description: "Gain endorsements, request recommendations, and track visibility.", icon: FaChartLine },
  { title: "Networking Events", description: "Attend virtual and in-person events to expand your network.", icon: FaUsers },
];

export default TrvllrSocial;
